import { createSelector } from "reselect";


const getFiltersSelector = (store) => {
    return store.filterItems.filterItems;
}

export const getFilters = createSelector(getFiltersSelector, (filterItems) => {
    return filterItems.filter(u => true);
})


export const getIsFetchingFilter = (store) => {
    return store.filterItems.isFetchingFilter;
}

export const getIsFetchingItems = (store) => {
    return store.catologItems.isFetchingItems;
}

export const getIsFetchingItemsMoby = (store) => {
    return store.catologItems.isFetchingItemsMoby;
}

export const getCheckedFiltr = (store) => {

    return store.filterItems.checked;
}

export const getCatalogItemsSelect = (store) => {
    return store.catologItems.catologItems;
}

export const getPageSize = (store) => {
    return store.catologItems.pageSize;
}

export const getTotalItemsCatolog = (store) => {
    return store.catologItems.totalItemsCount;
}

export const getCurrentPage = (store) => {
    return store.catologItems.currentPage;
}

export const getCatalogPageUrl = (store) => {
    return store.filterItems.catalogUrl;
}

export const getCountFiltrItems = (store) => {
    return store.filterItems.countItems;
}
export const getPriceFiltrItems = (store) => {
    return store.filterItems.getPriceSlide;
}
export const getPriceFiltrItemsMaxMin = (store) => {
    return store.filterItems.getPriceSlideMaxMin;
}
export const getFiltrOptionSort = (store) => {
    return store.filterSort.filterSort.option;
}

export const getFiltrUrl = (store) => {
    return store.filterItems.getUrlFiltr;
}

export const getValueSelected = (store) => {
    return store.filterSort.valueSelected;
}
export const getisFetchingSelect = (store) => {
    return store.filterSort.isFetchingSelect;
}
export const getBasketItemsId = (store) => {
    return store.catologItems.basketIdItems;
}
export const getBasketIdItemsCanBuy = (store) => {
    return store.catologItems.arBasketItemsCanBuy;
}
export const getTagCloudFiltr = (store) => {
    return store.filterItems.tagCloudFiltr;
}

export const getItemStore = (store) => {
    return store.item.item;
}
export const GetColorSimilar = (store) => {
    if (store.item.colorSemilar.ORGANZA_COLOR !== undefined)
        if (store.item.colorSemilar.ORGANZA_COLOR.NAMEVALUE.length > 0) {
            return store.item.colorSemilar;
        } else {
            return null;
        }


}
export const GetColorIdSimilar = (store) => {
    if (store.item.coloridSemilar.color_id !== undefined)
        if (store.item.coloridSemilar.color_id.SEMILIAR.length > 0) {
            return store.item.coloridSemilar;
        } else {
            return null;
        }
}
export const GetColorIdSimilarCount = (store) => {
    return store.item.coloridSemilarCount;
}
export const GetColorIdSimilarUrl = (store) => {
    if (store.item.item.ELEMENT_DATA !== undefined)

        try {
            var aArray = store.item.item.ELEMENT_DATA[0].color_id;
            if (aArray.VALUE !== undefined) {

                return `/catalog/?tagname=${aArray.VALUE.trim()}&filter[${aArray.CODE.trim()}][]=${aArray.VALUE.trim()}`;
            }
        } catch (error) {
            return null;
        }
}
export const GetSeriesSimilar = (store) => {
    if (store.item.seriesSemilar.series !== undefined)
        if (store.item.seriesSemilar.series.SEMILIAR.length > 0) {
            return store.item.seriesSemilar;
        } else {
            return null;
        }
}
export const GetSeriesSimilarUrl = (store) => {
    if (store.item.item.ELEMENT_DATA !== undefined)
        try {
            var aArray = store.item.item.ELEMENT_DATA[0].series;
            if (aArray.VALUE !== undefined) {
                return `/catalog/?tagname=${aArray.VALUE.trim()}&filter[${aArray.CODE.trim()}][]=${aArray.VALUE_ENUM_ID.trim()}`;
            }
        } catch (error) {
            return null;
        }
}
export const GetSeriesSimilarCount = (store) => {
    return store.item.seriesSemilarCount;
}
export const GetCollectionSimilar = (store) => {
    if (store.item.collectionSemilar.collection !== undefined)
        if (store.item.collectionSemilar.collection.SEMILIAR.length > 0) {
            return store.item.collectionSemilar;
        } else {
            return null;
        }
}
export const GetCollectionSimilarUrl = (store) => {
    if (store.item.item.ELEMENT_DATA !== undefined)
        try {
            var cArray = store.item.item.ELEMENT_DATA[0].collection;
            if (cArray.VALUE[0] !== undefined) {
                return `/catalog/?tagname=${cArray.VALUE[0].trim()}&filter[${cArray.CODE.trim()}][]=${cArray.VALUE_ENUM_ID[0].trim()}`;
            }
        } catch (error) {
            return null;
        }
}
export const GetCollectionSimilarCount = (store) => {
    return store.item.collectionSemilarCount;
}
export const GetArtyclesSimilar = (store) => {
    if (store.item.articlesSemilar.article !== undefined)
        if (store.item.articlesSemilar.article.SEMILIAR.length > 0) {
            return store.item.articlesSemilar;
        } else {
            return null;
        }
    // console.log(store.item.articlesSemilar)
}
export const GetArtyclesSimilarUrl = (store) => {
    if (store.item.item.ELEMENT_DATA !== undefined)
        try {
            var aArray = store.item.item.ELEMENT_DATA[0].article;
            if (aArray.VALUE !== undefined) {

                return `/catalog/?tagname=${aArray.VALUE.trim()}&filter[${aArray.CODE.trim()}][]=${aArray.VALUE.trim()}`;
            }
        } catch (error) {
            return null;
        }
}
export const GetArtyclesSimilarCount = (store) => {
    return store.item.articlesSemilarCount;
}
export const getIsFetchingItem = (store) => {
    return store.item.isFetchingItem;
}
export const getIsOpenShopItem = (store) => {
    return store.item.isOpenShop;
}
export const getTagCloudItems = (store) => {
    return store.indexPage.itemsTag;
}

export const getIsFetchingTagsItems = (store) => {
    return store.indexPage.isFetchingTagsItems;
}

export const GetProducerSimilarUrl = (store) => {
    if (store.item.item.ELEMENT_DATA !== undefined)
        // console.log(store.item.item.ELEMENT_DATA)
        try {
            var aArray = store.item.item.ELEMENT_DATA[0].producer;
            if (aArray.VALUE !== undefined) {
                var c = {};
                aArray.VALUE_XML_ID.map((i, k) => {
                    c[k] = `/collections/${i.trim()}/`;
                })
            }
            return c;
        } catch (error) {
            return null;
        }
}

export const GetShopOrder = (store) => {
    // const arBasketItemsCanBuy =  [['78524', '5.00'],['77791', '1.00'], ['103571', '1.00']];
    const arBasketItemsCanBuy =   getBasketIdItemsCanBuy(store);
    /*    debugger
  pp_id:  props.item.ELEMENT_DATA[0].CATALOG_PRICE_ID_1
  dpu:  CODE
  p_id:  ID
  p:  CATALOG_PRICE_1
  name:  NAME
    */
    if (store.item.item.ELEMENT_DATA !== undefined)
        try {
            var aArray = store.item.item.ELEMENT_DATA[0];
            if (aArray !== undefined) {

                return (
                    {
                        pp_id: aArray.CATALOG_PRICE_ID_1,
                        dpu: aArray.CODE,
                        p_id: aArray.ID,
                        p: aArray.CATALOG_PRICE_1,
                        name: aArray.NAME,
                        image: aArray.TIMTHUB,
                        resultCanBuy: arBasketItemsCanBuy.find(item => item[0] === aArray.ID),
                        mesureRatio: store.item.item.MEASURE_RATIO
                    }
                );
            }
        } catch (error) {
            return {
                pp_id: null,
                dpu: null,
                p_id: null,
                p: null,
                name: null,
            };
        }
}